import createWarmupElement from "../../../pages/survey/questions/create-statement-element";
import makeId from "../../../pages/survey/questions/make-id";

export default function (context) {
    const $context = $(context);
    const $warmupContainer = $context.find('.warmups-list-part');
    const $warmupImportButton = $context.find('.import-warmups-from-file');

    // Clear warmup container
    $warmupContainer.html(null);
    $warmupImportButton.addClass('hide');

    for (let i = 1; i <= 3; i++) {
        const warmupImageHtml = createWarmupElement(
            $context.find('[data-warmup-image-template]'),
            null,
            '--warmup-ID--'
        )
            .prop('outerHTML')
            .replaceAll('--CLOUD-OBJECT-ID--', makeId(8));

        $(warmupImageHtml).appendTo($warmupContainer);
    }
}
